import { render, staticRenderFns } from "./MailMagazineTerm.vue?vue&type=template&id=46ae841c&scoped=true&"
import script from "./MailMagazineTerm.vue?vue&type=script&lang=ts&"
export * from "./MailMagazineTerm.vue?vue&type=script&lang=ts&"
import style0 from "./MailMagazineTerm.vue?vue&type=style&index=0&id=46ae841c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae841c",
  null
  
)

export default component.exports